import { render, staticRenderFns } from "./AvailabilityFullCalendar.vue?vue&type=template&id=65bd754e"
import script from "./AvailabilityFullCalendar.vue?vue&type=script&lang=js"
export * from "./AvailabilityFullCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports